export default __webpack_public_path__ + "static/media/slide4.dce080e1.jpg";